module.exports = __webpack_public_path__ + "img/省水標章NEW.09e843ea.jpg";